import React, { useState } from "react";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Button,
  Divider,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "../assets/images/Logo.png";
import "../assets/css/Banner.css";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { AutoGraph, Logout, Person } from "@mui/icons-material";
const Banner = (props) => {
  const isSmallScreen = useMediaQuery("(max-width:800px)");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsDrawerOpen(open);
  };

  const menuItems = [
    { text: "Home", link: "/app/events" },
    { text: "Availability", link: "/app/availability" },
    { text: "Integrations", link: "/app/integrations" },
    { text: "Pricing", link: "/pricing" },
    props.data
      ? {
          text: props.data.username,
          link: "/app/profile",
          content: "e",
        }
      : "",
  ];
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState();

  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };
  const Hover = (props) => {
    return (
      <div
        className="hovered font"
        style={{ fontSize: "22px" }}
        onClick={() => {
          setOpen(false);
          props.onClick();
        }}
      >
        {props.children}
      </div>
    );
  };
  const navigate = useNavigate();
  return (
    <div className="fixed">
      <div className="nav">
        <div className="subnav">
          <div className="logo">
            <a href="/">
              <img alt="logo" src={Logo} className="logo-image" />
            </a>
          </div>
          {isSmallScreen ? (
            <>
              <IconButton
                className="menu-icon"
                onClick={() => setIsDrawerOpen(!isDrawerOpen)}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
              >
                <List>
                  {menuItems.map((item) =>
                    (item.text === "Login" &&
                      props.token &&
                      props.token !== "undefined") ||
                    !item.text ? (
                      ""
                    ) : (
                      <ListItem
                        button
                        component="a"
                        href={!item.action && item.link}
                        key={item.text}
                      >
                        {item.text === "Login" || item.text === "Logout" ? (
                          <Button
                            variant="contained"
                            className="drawer-button"
                            onClick={
                              item.action ? () => item.action() : console.log()
                            }
                          >
                            {item.text}
                          </Button>
                        ) : (
                          <ListItemText primary={item.text} />
                        )}
                      </ListItem>
                    )
                  )}
                </List>
              </Drawer>
            </>
          ) : (
            <>
              <Popper
                open={open}
                anchorEl={anchorEl}
                placement={placement}
                transition
                style={{ zIndex: 10000, minWidth: "200px" }}
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper
                      style={{
                        padding: "10px 0",
                        boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <Hover
                        style={{ color: "#3f51b5", cursor: "pointer" }}
                        onClick={() => {
                          navigate("/app/profile");
                        }}
                      >
                        <Typography variant="body1" className="flex align">
                          <Person style={{ marginRight: "10px" }} />
                          My Profile
                        </Typography>
                      </Hover>{" "}
                      {props?.data?.role.toLowerCase() != "starter" && (
                        <Hover
                          style={{ color: "#3f51b5", cursor: "pointer" }}
                          onClick={() => {
                            navigate("/app/analytics");
                          }}
                        >
                          <Typography variant="body1" className="flex align">
                            <AutoGraph style={{ marginRight: "10px" }} />
                            Analytics
                          </Typography>{" "}
                        </Hover>
                      )}
                      <Divider />
                      <Hover
                        style={{ color: "#3f51b5", cursor: "pointer" }}
                        onClick={() => {
                          props.logout();
                        }}
                      >
                        <Typography variant="body1" className="flex align">
                          <Logout style={{ marginRight: "10px" }} />
                          Logout
                        </Typography>{" "}
                      </Hover>
                    </Paper>
                  </Fade>
                )}
              </Popper>
              {menuItems.map((item) =>
                (item.text === "Login" &&
                  props.token &&
                  props.token !== "undefined") ||
                !item.text ? (
                  ""
                ) : (
                  <a
                    href={
                      !item.action &&
                      !(item.link == "/app/profile") &&
                      item.link
                    }
                    onClick={
                      item.link == "/app/profile" && handleClick("bottom-end")
                    }
                    key={item.text}
                    className={
                      item.text === "Availability" ||
                      item.text === "Integrations"
                        ? "menu-item long-item"
                        : item.content
                        ? "menu-item with-content"
                        : "menu-item"
                    }
                  >
                    {item.text === "Login" || item.text === "Logout" ? (
                      <Button
                        variant="contained"
                        className="menu-button"
                        onClick={
                          item.action ? () => item.action() : console.log()
                        }
                      >
                        {item.text}
                      </Button>
                    ) : (
                      <div className="menu-text">
                        {item.content ? (
                          <div className="content-wrapper flex justify">
                            <div className="content-icon">{item.text[0]}</div>
                            <div className="content-label">{item.text}</div>
                          </div>
                        ) : (
                          item.text
                        )}
                      </div>
                    )}
                  </a>
                )
              )}
            </>
          )}
        </div>
      </div>
      <Divider />
    </div>
  );
};

export default Banner;
